import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import type { PersistQueryClientOptions } from '@tanstack/query-persist-client-core';
import { APP_VERSION } from '../appMeta';
import { isNoteScopedQueryKey, isSchoolScopedQueryKey } from './keys';
import { queryClient } from './queryClient';

const REACT_QUERY_PERSIST_KEY = 'cp.reactQuery.cache.v2';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export function createReactQueryPersister() {
  if (typeof window === 'undefined') return null;
  return createSyncStoragePersister({
    storage: window.localStorage,
    key: REACT_QUERY_PERSIST_KEY,
  });
}

export function buildSchoolQueryPersistOptions(): Omit<PersistQueryClientOptions, 'queryClient'> | null {
  const persister = createReactQueryPersister();
  if (!persister) return null;
  return {
    persister,
    buster: APP_VERSION,
    maxAge: ONE_DAY_MS,
    dehydrateOptions: {
      shouldDehydrateQuery: (query) =>
        query.state.status === 'success' &&
        (isSchoolScopedQueryKey(query.queryKey) || isNoteScopedQueryKey(query.queryKey)),
    },
  };
}

export function buildPersistQueryClientOptions(): PersistQueryClientOptions | null {
  const persistOptions = buildSchoolQueryPersistOptions();
  if (!persistOptions) return null;
  return {
    queryClient,
    ...persistOptions,
  };
}
